import { IItemForGetShortInfo, TFileId, IServerError, IUserEmailValidationError, IUpdateUser } from 'types';
import { createContext } from 'react';

export type TEditUserFilePath = Nullable<string>;
export type TSourceUrlLocally = Nullable<string>;
export type TEditUserSelectedItem = string | null;
export type TTypeOfEditUserModalWindow =
	| null
	| 'toConfirmFieldsClearing'
	| 'toConfirmSubmit'
	| 'success'
	| 'error'
	| 'fileSizeExceeded'
	| 'fileUploadError'
	| 'invalidFileFormat';
export interface IInitialFormData {
	name: string;
	surName: string;
	email: string;
	phoneNumber: string;
	selectedRole: TEditUserSelectedItem;
	selectedCustomer: TEditUserSelectedItem;
	selectedCustomers: string[];
	selectedRestaurants: string[];
	filePath: TEditUserFilePath;
}

export interface IEditUserState {
	needRefetchData: boolean;
	initialFormData: IInitialFormData | null;
	userID: string;
	fileId: TFileId;
	sourceUrlLocally: TSourceUrlLocally;
	filePath: TEditUserFilePath;
	name: string;
	surName: string;
	email: string;
	phoneNumber: string;
	fetchedRoles: IItemForGetShortInfo[];
	selectedRole: TEditUserSelectedItem;
	fetchedCustomers: IItemForGetShortInfo[];
	selectedCustomer: TEditUserSelectedItem;
	selectedCustomers: string[];
	fetchedRestaurants: IItemForGetShortInfo[];
	initialIDsSelectedRestaurant: string[];
	selectedRestaurants: string[];
	dataForSubmit: IUpdateUser | null;
	typeOfModalWindow: TTypeOfEditUserModalWindow;
	errorResponseData: IServerError<IUserEmailValidationError> | null;
}

export const editUserInitialState: IEditUserState = {
	needRefetchData: false,
	initialFormData: null,
	userID: '',
	fileId: null,
	sourceUrlLocally: null,
	filePath: null,
	name: '',
	surName: '',
	email: '',
	phoneNumber: '',
	fetchedRoles: [],
	selectedRole: null,
	fetchedCustomers: [],
	selectedCustomer: null,
	selectedCustomers: [],
	fetchedRestaurants: [],
	initialIDsSelectedRestaurant: [],
	selectedRestaurants: [],
	dataForSubmit: null,
	typeOfModalWindow: null,
	errorResponseData: null,
};

export interface IEditUserContext extends IEditUserState {
	refetchData(value: boolean): void;
	setFile(fileId: TFileId, sourceUrlLocally: TSourceUrlLocally): void;
	deletePhoto(): void;
	changeName(value: string): void;
	changeSurName(value: string): void;
	changeEmail(value: string): void;
	changePhoneNumber(value: string): void;
	setFetchedRoles(value: IItemForGetShortInfo[]): void;
	setRole(value: TEditUserSelectedItem): void;
	setFetchedCustomers(value: IItemForGetShortInfo[]): void;
	setCustomer(value: TEditUserSelectedItem): void;
	setCustomers(value: string[]): void;
	setFetchedRestaurants(value: IItemForGetShortInfo[]): void;
	setRestaurants(value: string[]): void;
	setDataForSubmit(value: IUpdateUser | null): void;
	changeTypeOfModalWindow(value: TTypeOfEditUserModalWindow): void;
	showErrorModalWithInfo(value: IServerError<IUserEmailValidationError> | null): void;
	resetFields(): void;
}

export const EditUserContext = createContext<IEditUserContext>({
	refetchData: () => undefined,
	setFile: () => undefined,
	deletePhoto: () => undefined,
	changeName: () => undefined,
	changeSurName: () => undefined,
	changeEmail: () => undefined,
	changePhoneNumber: () => undefined,
	setFetchedRoles: () => undefined,
	setRole: () => undefined,
	setFetchedCustomers: () => undefined,
	setCustomer: () => undefined,
	setCustomers: () => undefined,
	setFetchedRestaurants: () => undefined,
	setRestaurants: () => undefined,
	setDataForSubmit: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	showErrorModalWithInfo: () => undefined,
	resetFields: () => undefined,
	...editUserInitialState,
});
